import { gql } from "@apollo/client";

export const DELETE_CLIENT_EMAIL_CONNECTION = gql`
  mutation deleteClientEmailConnection($id: String!) {
    client {
      deleteClientEmailConnection(id: $id) {
        success
      }
    }
  }
`;
